
import { defineComponent } from 'vue';
import ResizableImage from '@/shared/components/ResizableImage.vue';

export default defineComponent({
  components: {
    ResizableImage,
  },
  emits: ['edit'],
  props: {
    estateAgent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    onEdit() {
      this.$emit('edit', this.estateAgent.frontUserId);
    },
  },
});
